export default {
  setUnreadNotification({ commit }, item) {
    commit('SET_UNREAD_NOTIFICATION', item)
  },

  addUnreadNotification({ commit }, item) {
    commit('ADD_UNREAD_NOTIFICATION', item)
  },

  clearUnreadNotification({ commit }, imei) {
    commit('CLEAR_UNREAD_NOTIFICATION', imei)
  }
}